import React, { useCallback, useState, useContext } from "react";
import {  Box, Dialog, DialogContent, IconButton, Typography } from "@mui/material"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import { shipmentApiNm } from "constants/shipmentConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { useEffect } from "react";
import PaperComponent from "components/PaperComponent";
import JobOrderData from "pages/Menu1/AddJobOrder/JobOrderData";
import { alertWarning } from "components/Alert";
import useCompactLayout from "hooks/useCompactLayout";
import { blueGrey } from "@mui/material/colors";
import { CloseRounded } from "resource/muiImport";

const PrintJobOrderDialog = ({ dialogOpen, setDialogOpen, selectedId, onFinish}) => {

  const {ax, msData} = useContext(GlobalStateContext)
  const [shipmentData, setShipmentData] = useState(null)
  const isCompact = useCompactLayout()

  const handleClose = useCallback(()=>{
    setDialogOpen(false)
  }, [setDialogOpen])


  useEffect(()=>{
    if(dialogOpen){
      ax.post(shipmentApiNm.getShipment, {ShpmId: selectedId, a:"b"}).then(value=>{
        if(value.data){

          if(value.data.length !== 1){
            alertWarning("ไม่พบข้อมูบใบแจ้งลาก")
            return
          }


          setShipmentData(value.data[0])
        }
      })
    }
  }, [ax, dialogOpen, selectedId])

  if (isCompact) {
    return (
      <Dialog open={dialogOpen} fullScreen onClose={handleClose} aria-labelledby="pjo-compact-title"
        PaperProps={{ sx: { bgcolor: blueGrey[50] } }}>
        <Box sx={{
          display: "flex", alignItems: "center", gap: 0.5, px: 0.5, pb: 0.5,
          pt: "calc(4px + env(safe-area-inset-top))", bgcolor: "primary.main", color: "primary.contrastText"
        }}>
          <IconButton color="inherit" aria-label="ปิด" onClick={handleClose}><CloseRounded /></IconButton>
          <Box flex={1} minWidth={0}>
            <Typography id="pjo-compact-title" noWrap sx={{ fontWeight: 700, fontSize: 17, lineHeight: 1.3 }}>
              เพิ่ม/พิมพ์ใบงาน
            </Typography>
            <Typography noWrap sx={{ fontSize: 13, opacity: 0.85 }}>
              {shipmentData ? [shipmentData.JobNo, shipmentData.Bkg && `Bkg ${shipmentData.Bkg}`].filter(Boolean).join("  ·  ") : "กำลังโหลด..."}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
          <JobOrderData compact
            ax={ax} msData={msData}
            shipmentData={shipmentData}
            onFinish={onFinish}
          />
        </Box>
      </Dialog>
    )
  }

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="sm" >
      <DialogHeader  handleDialogClose={handleClose}
        title={"พิมพ์ใบงาน"}
        onDeleteClick={null}
      >
      </DialogHeader>
      <DialogContent >
        <JobOrderData
        ax={ax} msData={msData}
        shipmentData={shipmentData}
        onFinish={onFinish}
        />
      </DialogContent>
      <DialogFooter okText="" cancelText="ปิด"
          handleDialogClose={handleClose}
          handleDialogOk={null} />
    </Dialog>
  )
}

export default PrintJobOrderDialog
